module.exports = __webpack_public_path__ + "media/images/thumbs/physanims/a2-11-c7a1f13201b5f46f9d40843fd01ccea3.jpg";